import { Theme } from '@just-in-types';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import { adminReload } from '../store/actions';
import { IState } from '../store/reducers';
import Button from './Button';
import Text from './Text';

interface NewVersionButtonStateProps {
  colors: Theme.Colors;
  newVersionAvailable: boolean;
}

type NewVersionButtonProps = NewVersionButtonStateProps;

interface NewVersionButtonState {
  expanded: boolean;
}

const ButtonWrapper = styled('div')`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;

const StyledButton = styled(Button)`
  transition: all ease-in-out 250ms;
`;

class NewVersionButton extends React.Component<
  NewVersionButtonProps,
  NewVersionButtonState
> {
  public state: NewVersionButtonState = { expanded: false };

  public render() {
    const { colors, newVersionAvailable } = this.props;
    const { expanded } = this.state;
    const buttonAction = expanded ? adminReload : this.toggleExpanded;
    const buttonBg = expanded ? colors.success : colors.warning;
    const buttonText = expanded
      ? 'New version available. Click here to reset!'
      : '!';

    if (newVersionAvailable) {
      return (
        <ButtonWrapper>
          <StyledButton bg={buttonBg} onClick={buttonAction}>
            <Text>{buttonText}</Text>
          </StyledButton>
        </ButtonWrapper>
      );
    } else {
      return null;
    }
  }

  private toggleExpanded = () =>
    this.setState(({ expanded }) => ({ expanded: !expanded }));
}

const mapStateToProps = ({
  telemetry: { newVersionAvailable },
  theme: { colors },
}: IState) => ({
  colors,
  newVersionAvailable,
});

export default connect<NewVersionButtonStateProps>(mapStateToProps)(
  NewVersionButton,
);



// WEBPACK FOOTER //
// ./src/components/NewVersionButton.tsx